import React from "react";
import { X } from "lucide-react";

export function Chip({ children, onRemove }: { children: React.ReactNode; onRemove?: () => void }) {
  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-gray-100 px-2.5 py-1 text-xs text-gray-700 ring-1 ring-gray-200">
      {children}
      {onRemove && (
        <button onClick={onRemove} className="ml-1 rounded-full p-0.5 hover:bg-gray-200" aria-label="rimuovi">
          <X className="h-3 w-3" />
        </button>
      )}
    </span>
  );
}
